import React, { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';

const WalletDetails = lazy(() => import('../../container/borrower/wallet/walletDetails'));

function OwnerRoute() {
  return (
    <Routes>
      <Route path="details" element={<WalletDetails />} />
    </Routes>
  );
}

export default OwnerRoute;
